import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { Subscription } from 'rxjs';
import { navItems } from './sidebar-data';
import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { NavService } from '../../../../services/nav.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '../../../../../../src/app/material.module';
import { CommonModule } from '@angular/common';
import { AppHorizontalNavItemComponent } from './nav-item/nav-item.component';
import { BrandingComponent } from '../../vertical/sidebar/branding.component';
import { AuthService } from '@auth-suite-services/services';
import { filterNavItemsByScopes } from '../../../../utils/filter-nav-items.util';

@Component({
  selector: 'app-horizontal-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TablerIconsModule,
    MaterialModule,
    AppHorizontalNavItemComponent,
    BrandingComponent
  ],
  templateUrl: './sidebar.component.html'
})
export class AppHorizontalSidebarComponent implements OnInit, OnDestroy {
  navItems: NavItem[] = [];
  parentActive = '';

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  private authSubscription = Subscription.EMPTY;

  constructor(
    public navService: NavService,
    public router: Router,
    public authService: AuthService,
    media: MediaMatcher,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 1100px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.router.events.subscribe(
      () => (this.parentActive = this.router.url.split('/')[1])
    );
  }

  ngOnInit(): void {
    this.refreshNavItems();
    this.authSubscription = this.authService.userProfile$.subscribe(() => {
      this.refreshNavItems();
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  // Filter SideNav by Amber Auth0 scopes. 18/09/2026 CN
  private refreshNavItems(): void {
    this.navItems = filterNavItemsByScopes(navItems, (scopes) =>
      this.authService.userHasScopes(scopes)
    );
  }

  // Match parent dropdown active styling for all menus like SMS/E-mail Functions 14/07/2026 DW
  isParentActive(item: any): boolean {
    if (!item) {
      return false;
    }

    if (item.children?.length) {
      return item.children.some((child: any) => this.isDescendantActive(child));
    }

    if (!item.route) {
      return false;
    }

    const parentSeg = String(item.route).replace(/^\//, '').split('/')[0];
    return parentSeg === this.parentActive;
  }

  private isDescendantActive(item: any): boolean {
    if (!item) {
      return false;
    }

    if (item.route) {
      const path = item.route.startsWith('/') ? item.route : `/${item.route}`;
      const currentUrl = this.router.url.split('?')[0];
      if (currentUrl === path || currentUrl.startsWith(`${path}/`)) {
        return true;
      }
    }

    return !!item.children?.some((child: any) => this.isDescendantActive(child));
  }
}
